import React, { Component } from 'react';

import ModelServices from '../../services/Settore';

import CommonForm from '@common/components/form';
import { message } from 'antd';

const model = {
  layout: 'vertical',
  multistep: false,
  rows: [
    {
      cols: [
        {
          span: 24,
          items: [
            {
              type: 'input',
              label: 'Nome',
              type_string: 'text', // field type
              name: 'nome_settore',
              validations: [
                {
                  type: 'required',
                  error_message: 'Campo obbligatorio',
                },
              ],
            },
            /*
            {
              type: 'textarea',
              label: 'Descrizione',
              type_string: 'text', // field type
              name: 'descrizione',
              props: {
                autosize: true,
                size: 'large',
                prefix: <Icon type="file" style={{ color: 'rgba(0,0,0,.25)' }} />,
              }
            },
            {
              type: 'datepicker',
              label: 'Valido dal',
              name: 'valido_dal',
              props: {
                size: 'large'
              },
            },
            {
              type: 'datepicker',
              label: 'Valido al',
              name: 'valido_al',
              props: {
                size: 'large'
              },
            },*/
          ],
        },
      ],
    },
    {
      cols: [
        {
          items: [
            {
              name: 'btn',
              type: 'submit',
              text: 'Conferma',
              btn_type: 'primary'
            },
          ],
        },
      ],
    },
  ],
  onSubmit: 'submitted',
}

class CreateModel extends Component {
  base_url = '/settori'

  state = {
    loading: false
  }

  submit(data) {

    if (!this.state.loading) {
      this.setState({ loading: true });

      ModelServices.create(data, () => {
        message.success("Operazione effettuata con successo");
        this.props.oncreate();
        this.setState({ loading: false });
      }, () => {
        this.setState({ loading: false })
      })
    }
  }

  render() {
    return (
      <CommonForm
        wrappedComponentRef={inst => (this.formRef = inst)}
        loading={this.state.loading || false}
        form_model={model}
        submitted={(data) => this.submit(data)}
      />
    );
  }
}
export default CreateModel;